// bubbletexts.js
const bubbleTexts = [
  "How can I help you?",
  "What are your queries?",
  "Need assistance with something?",
  // Add more texts as needed
];

export default bubbleTexts;
